import * as React from "react";

const LogIn: React.FC = () => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    viewBox="0 0 3679.2 3250.6">
<g fill="#424242">
   <path d="M3517.8,1009c-80-189.2-194.5-359-340.3-504.8s-315.7-260.3-504.8-340.3C2476.8,81,2268.8,39,2054.5,39
       s-422.4,42-618.3,124.9c-367.7,155.5-663,444.3-827.5,805.1c-49.4,108.3,29.3,231.4,148.3,231.4l0,0c63.8,0,121.8-37.1,148.3-95.2
       c199.5-437.3,641.5-741.7,1153-740.2c696.2,2.1,1258.5,566.1,1258.5,1262.3c0,696-566.3,1262.3-1262.3,1262.3
       c-509.8,0-950-303.8-1149.1-739.9c-26.5-58.1-84.5-95.5-148.5-95.5l0,0c-118.9,0-197.7,123-148.3,231.2
       c163.6,358.8,457.6,648.7,827.6,805.2c195.9,82.9,403.9,124.9,618.3,124.9c214.3,0,422.4-42,618.3-124.9
       c189.1-80,359-194.5,504.8-340.3s260.3-315.7,340.3-504.8c82.9-195.9,124.9-403.9,124.9-618.3
       C3642.7,1412.9,3600.7,1204.9,3517.8,1009z"/>
   <path d="M1935.9,1991.3c-63.6,63.6-63.6,166.8,0,230.5l0,0c63.6,63.6,166.8,63.6,230.5,0l517.5-517.5
       c42.5-42.5,42.5-111.4,0-153.9l-517.5-517.5c-63.6-63.6-166.8-63.6-230.5,0l0,0c-63.6,63.6-63.6,166.8,0,230.5l201.1,201.1H203.5
       c-90,0-163,73-163,163l0,0c0,90,73,163,163,163H2137L1935.9,1991.3z"/>
</g>
</svg>;
};

export default React.memo(LogIn);
